import { guideSteps } from "@/mocks/home";

export default function GuideSteps() {
  return (
    <section id="guide" className="w-full bg-background-100">
      <div className="mx-auto w-full px-4 py-20 md:px-8 md:py-32">
        <div className="mb-14 max-w-2xl md:mb-20">
          <p className="font-label text-xs tracking-[0.3em] text-accent-600 md:text-sm">
            HOW TO USE
          </p>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            三步访问指南
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            不需要复杂操作。记住下面三件事，就能在黑料地址换域名时依然顺利找到入口。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8 lg:gap-14">
          {guideSteps.map((item) => (
            <div key={item.step} className="border-t-2 border-foreground-950 pt-6 md:pt-8">
              <span className="font-heading text-4xl font-black text-primary-500 md:text-5xl">
                {item.step}
              </span>
              <h3 className="mt-6 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {item.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}